import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { DateFormat } from '~/components/ui';
import { CommentUser } from '~/lib/discussions/types';
import PlusMemberIcon from '../../public/plus-member.svg';
import Image from 'next/image';
import { useContext } from 'react';
import { PDPContext } from '~/lib/product/context';
import { Deal } from '~/types/deal';
import Link from 'next/link';

function UserStatus({
  user,
  purchased,
}: {
  user: CommentUser;
  purchased: boolean;
}) {
  if (!user.has_plus && !user.has_briefcase && !purchased) {
    return null;
  }

  return (
    <div className="mt-1 flex items-center gap-3">
      {(user.has_plus || user.has_briefcase) && (
        // eslint-disable-next-line @next/next/no-html-link-for-pages
        <Link href="/plus">
          <span className="sr-only">Plus member</span>
          <Image
            src={PlusMemberIcon}
            height="16"
            width="65"
            alt=""
            role="presentation"
          />
        </Link>
      )}
      {purchased && (
        <div className="text-xs">
          <FontAwesomeIcon icon={faCheck} className="mr-1 text-green-500" />
          <span className="text-xs font-bold">Verified Purchaser</span>
        </div>
      )}
    </div>
  );
}

function UserCreatorBadge() {
  return (
    <span className="ml-3 flex flex-wrap content-center rounded bg-skys-the-limit/40 py-0.5 px-1.5 align-middle text-xs text-midnight">
      Founder team
    </span>
  );
}

export function UserMetaV2({
  user,
  posted,
  purchased,
}: {
  user: CommentUser;
  posted: string;
  purchased: boolean;
}) {
  const { deal }: { deal: Deal } = useContext(PDPContext);
  const isCreator = (deal?.partner_user_ids || []).includes(user.id);

  return (
    <div className="flex w-full flex-col gap-y-2">
      <div>
        <span className="flex font-bold">
          <Link href={`/profile/${user.username}/`} target="_blank">
            <span className="truncate">{user.username}</span>
          </Link>
          {isCreator && <UserCreatorBadge />}
        </span>
        <UserStatus user={user} purchased={purchased} />
      </div>
      <div className="text-xs text-gray-400">
        <DateFormat date={posted} format={'MMM. DD, YYYY, HH:mm'} />
        {!isCreator && ` | Deals Bought: ${user.deals_purchased}`}
        {' | '}
        Member Since: <DateFormat date={user.date_joined} format={'MM/DD/YY'} />
      </div>
    </div>
  );
}
